import React, { useRef, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const SegmentedControl = () => {
  const location = useLocation();
  const workLinkRef = useRef(null);
  const aboutLinkRef = useRef(null);
  const sliderRef = useRef(null);
  const [sliderStyle, setSliderStyle] = useState({});

  const isWorkActive =
    location.pathname === "/" || location.pathname === "/work";
  const isAboutActive = location.pathname === "/about";

  useEffect(() => {
    const activeRef = isWorkActive ? workLinkRef : aboutLinkRef;

    if (activeRef.current && sliderRef.current) {
      const { offsetLeft, offsetWidth } = activeRef.current;

      setSliderStyle({
        width: `${offsetWidth}px`,
        transform: `translateX(${offsetLeft}px)`,
      });
    }
  }, [location.pathname]);

  return (
    <div className="segmented-control">
      <div className="segment-slider" ref={sliderRef} style={sliderStyle}></div>
      <Link
        to="/work"
        ref={workLinkRef}
        className={`segment-button ${isWorkActive ? "active" : ""}`}
        aria-current={isWorkActive ? "page" : undefined}
      >
        Work
      </Link>
      <Link
        to="/about"
        ref={aboutLinkRef}
        className={`segment-button ${isAboutActive ? "active" : ""}`}
        aria-current={isAboutActive ? "page" : undefined}
      >
        About
      </Link>
    </div>
  );
};

export default SegmentedControl;
